//内容管理路由
export default {
    path: 'content',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '内容管理'},
    children: [
        //内容管理列表
        {
            path: 'list',
            component: () => import('@/views/content/list'),
            meta: { title: 'APP首页类别管理'},
			props: true
        },
		//内容管理
		// {
		//     path: 'order',
		//     component: () => import('@/views/hotel/order'),
		//     meta: { title: '订单列表'},
		// 	props: true
		// }
    ]
};
